import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface User {
  id: string;
  email: string;
  userType: 'Employer' | 'Contractor' | 'Admin';
}

interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  login: (email: string, password: string) => void;
  register: (email: string, password: string, userType: 'Employer' | 'Contractor') => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState<User | null>(null);

  const login = (email: string, password: string) => {
    // For now, determine user type based on email
    let userType: 'Employer' | 'Contractor' | 'Admin' = 'Employer';
    
    if (email === 'fxepro@gmail.com' || email.includes('admin')) {
      userType = 'Admin';
    } else if (email.includes('employer')) {
      userType = 'Employer';
    } else if (email.includes('contractor')) {
      userType = 'Contractor';
    }
    
    setUser({ id: '1', email, userType });
    
    // Redirect based on user type
    switch (userType) {
      case 'Admin':
        navigate('/app/admin/dashboard');
        break;
      case 'Employer':
        navigate('/app/employer/dashboard');
        break;
      case 'Contractor':
        navigate('/app/contractor/dashboard');
        break;
      default:
        navigate('/app/employer/dashboard');
    }
  };

  const register = (email: string, password: string, userType: 'Employer' | 'Contractor') => {
    setUser({ id: '1', email, userType });
    navigate(`/app/${userType.toLowerCase()}/dashboard`);
  };

  const logout = () => {
    setUser(null);
    navigate('/auth/login');
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      isAuthenticated: !!user,
      login, 
      register, 
      logout 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 